const defaultPhone = "919521873664";

export function getWhatsAppPhone() {
  return (process.env.REACT_APP_WHATSAPP_PHONE || defaultPhone).replace(/\D/g, "");
}

export const openWhatsApp = (product) => {
  const phone = getWhatsAppPhone();

  const message = `
Hello, I want to enquire about this gift:

Product: ${product.Tittle}
Description: ${product.Description}
Price: ₹${product.Price}
`;

  const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;

  window.open(url, "_blank");
};
